import { casingUtil } from '@/utils'

export const resolveAuthDown = casingUtil.snakeToCamel
